<template>
  <div class="home-page">
    <div class="header">
      <div class="cover-img">
        <div class="content">
          <CustomHeader></CustomHeader>
          <div class="wrapper">
            <div class="header">
              <div class="header__section pt-lg-5 pt-md-3 pt-sm-2 mt-lg-4">
                <div :class="{ 'show': showContent }" class="header__section-info">
                  <div class="title">{{ $t('header.aviation') }} <br> <span>BOSCHUNG </span></div>
                </div>
                <transition name="fade">
                  <div v-if="showImage" class="header__section-img"></div>
                </transition>
              </div>
            </div>
            <div class="description" ref="description">
              <b>Boschung</b>
              {{ $t('aviation.boschung.description') }}
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="body-section">
        <div class="content">
          <BoxSection
              position="left"
              :title="$t('aviation.boschung.urbanSweeper')"
              :descriptionLines="[
            $t('aviation.boschung.urbanSw'),
            $t('aviation.boschung.urbanSw2')
            ]"
              pdfLink="https://www.boschung.com/product/urban-sweeper-s2-0/"
              :pdfLabel="$t('viewDetails')"
              imageSrc="/img/avio/UrbanSweeperS2.0.png"
          />
          <BoxSection
              position="right"
              :title="$t('aviation.boschung.jetbroom') + ' 10000'"
              :description="$t('aviation.boschung.jetbroom10')"
              pdfLink="https://www.boschung.com/product/jetbroom-10000/"
              :pdfLabel="$t('viewDetails')"
              imageSrc="/img/avio/Jetbroom10000.png"
          />
          <BoxSection
              position="left"
              :title="$t('aviation.boschung.jetbroom') + ' 4000'"
              :description="$t('aviation.boschung.jetbroom40')"
              pdfLink="https://www.boschung.com/product/jetbroom-4000/"
              :pdfLabel="$t('viewDetails')"
              imageSrc="/img/avio/jetbroom4000.png"
          />
          <BoxSection
              position="right"
              title="PONY P3.0"
              :description="$t('aviation.boschung.pony')"
              pdfLink="https://www.boschung.com/product/pony-p3-0/"
              :pdfLabel="$t('viewDetails')"
              imageSrc="/img/avio/PonyP3.0.png"
          />
          <BoxSection
              position="left"
              :title="$t('aviation.boschung.imsSeriesTitle')"
              :description="$t('aviation.boschung.imsSeries')"
              pdfLink="https://www.boschung.com/product/ims/"
              :pdfLabel="$t('viewDetails')"
              imageSrc="/img/avio/BoschungIMSSERIES.png"
          />
          <BoxSection
              position="right"
              :title="$t('aviation.boschung.bMoves')"
              :description="$t('aviation.boschung.bMov')"
              pdfLink="https://www.boschung.com/product/bmoves/"
              :pdfLabel="$t('viewDetails')"
              imageSrc="/img/avio/bMoves-FieldService.png"
          />
          <BoxSection
              position="left"
              :title="$t('aviation.boschung.urbanSweeper2')"
              :descriptionLines="[$t('aviation.boschung.urbanSwep2'), $t('aviation.boschung.urbanSwep3')]"
              pdfLink="https://www.boschung.com/product/urban-sweeper-s2-0-autonomous/"
              :pdfLabel="$t('viewDetails')"
              imageSrc="/img/avio/UrbanSweeperautonomus.png"
          />
          <BoxSection
              position="right"
              :title="$t('aviation.boschung.bVision')"
              :description="$t('aviation.boschung.bVis')"
              pdfLink="https://www.boschung.com/product/bvision/"
              :pdfLabel="$t('viewDetails')"
              imageSrc="/img/avio/bVision.png"
          />
          <BoxSection
              position="left"
              :title="$t('aviation.boschung.snowbooster')"
              :description="$t('aviation.boschung.snowboosterSeries')"
              pdfLink="https://www.boschung.com/product/snowbooster/"
              :pdfLabel="$t('viewDetails')"
              imageSrc="/img/avio/SnowboosterSeries.png"
          />
          <BoxSection
              position="right"
              title="ATLAS"
              :descriptionLines="[
            $t('aviation.boschung.atlasDescription'),
            $t('aviation.boschung.p1'),
            $t('aviation.boschung.p2'),
            $t('aviation.boschung.p3')
          ]"
              pdfLink="https://www.boschung.com/product/atlas/"
              :pdfLabel="$t('viewDetails')"
              imageSrc="/img/avio/BoschungATLAS.png"
          />
          <BoxSection
              position="left"
              title="FlexiWet®"
              :description="$t('aviation.boschung.flexiwetDescription')"
              pdfLink="https://www.boschung.com/product/flexiwet/"
              :pdfLabel="$t('viewDetails')"
              imageSrc="/img/avio/FlexiWet.png"
          />
          <BoxSection
              position="right"
              title="Jetbroom 10000 T"
              :description="$t('aviation.boschung.jetbroom10Descr')"
              pdfLink="https://www.boschung.com/product/jetbroom-10000-t/"
              :pdfLabel="$t('viewDetails')"
              imageSrc="/img/avio/jetbroom1000T.png"
          />
          <BoxSection
              position="left"
              :title="$t('aviation.boschung.sdaSeries')"
              :description="$t('aviation.boschung.sdaSeriesDescr')"
              pdfLink="https://www.boschung.com/product/sda/"
              :pdfLabel="$t('viewDetails')"
              imageSrc="/img/avio/BoschungSDAseries.png"
          />
          <BoxSection
              position="right"
              :title="$t('aviation.boschung.fast')"
              :description="$t('aviation.boschung.fastDesc')"
              pdfLink="https://www.boschung.com/product/fast/"
              :pdfLabel="$t('viewDetails')"
              imageSrc="/img/avio/FastSystem.png"
          />
          <BoxSection
              position="left"
              title="CombiWet®"
              :description="$t('aviation.boschung.combwetDesc')"
              pdfLink="https://www.boschung.com/product/combiwet/"
              :pdfLabel="$t('viewDetails')"
              imageSrc="/img/avio/CombiWet.png"
          />
          <BoxSection
              position="right"
              :title="$t('aviation.boschung.iceEarly')"
              :description="$t('aviation.boschung.iceEarlyDesc')"
              pdfLink="https://www.boschung.com/product/ice-early-warning-system-airport/"
              :pdfLabel="$t('viewDetails')"
              imageSrc="/img/avio/iceEarly.png"
          />

          <BoxSection
              position="left"
              title="FullWet®"
              :description="$t('aviation.boschung.fullwetDesc')"
              pdfLink="https://www.boschung.com/product/fullwet/"
              :pdfLabel="$t('viewDetails')"
              imageSrc="/img/avio/CombiWet.png"
          />

          <BoxSection
              position="right"
              :title="$t('aviation.boschung.rCondition')"
              :description="$t('aviation.boschung.rConditionDesc')"
              pdfLink="https://www.boschung.com/product/r-condition/"
              :pdfLabel="$t('viewDetails')"
              imageSrc="/img/avio/r-condition.png"
          />

          <BoxSection
              position="left"
              :title="$t('aviation.boschung.rWeather')"
              :description="$t('aviation.boschung.rWeatherDesc')"
              pdfLink="https://www.boschung.com/product/r-weather/"
              :pdfLabel="$t('viewDetails')"
              imageSrc="/img/avio/r-weather.png"
          />

          <BoxSection
              position="right"
              :title="$t('aviation.boschung.itArc')"
              :description="$t('aviation.boschung.itArcDesc')"
              pdfLink="https://www.boschung.com/product/it-arctis/"
              :pdfLabel="$t('viewDetails')"
              imageSrc="/img/avio/it.png"
          />

          <MarqueeLogos />
        </div>

    </div>
    <div class="footer">
      <div class="cover-img">
        <div class="img">
          <div class="img3"></div>
        </div>
        <div class="content">
          <FooterSection></FooterSection>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import FooterSection from "@/components/Footer.vue";
import CustomHeader from "@/components/CustomHeader.vue";
import BoxSection from '@/components/BoxSection.vue'
import MarqueeLogos from '@/components/MarqueeLogos.vue';

export default {
  name: 'AvioBoschung',
  components: {
    FooterSection,
    CustomHeader,
    BoxSection,
    MarqueeLogos
  },
  data() {
    return {
      showImage: false,
      showContent: false,

    };
  },
  mounted() {
    this.showImage = true;
    setTimeout(() => {
      this.showContent = true;
    }, 500);
    setTimeout(() => {
      this.$nextTick(() => {
        this.$refs.description.classList.add('fade-in');
      });
    }, 500);
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/main.scss";

.home-page {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin: 0;
  padding: 0;
  overflow-y: auto;
}

.wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .header {
    width: 70vw;
    @include respond(tab-land) {
      width: 95vw;
    }
    @media only screen and (min-width: 1201px) and (max-width: 1499px) {
      width: 95vw;
    }

    &__section {
      display: flex;
      width: 100%;
      justify-content: space-between;
      //   align-items: flex-start;
      align-items: center;
      margin-top: 40px;
      @include respond(phone) {
        flex-direction: column;
        margin-top: 20px;
      }

      &-info {
        display: flex;
        flex-direction: column;
        gap: 10px;
        max-width: 530px;
        width: 100%;
        text-align: left;

        transform: translateY(-100%);
        opacity: 0;
        transition: transform 1.2s ease-out, opacity 2s ease-out;
        @include respond(phone) {
          text-align: center;
        }

        &.show {
          transform: translateX(0);
          opacity: 1;
        }

        .title {
          font-size: 100px;
          font-family: "Montserrat";
          color: $primary-blue;
          font-weight: bold;
          text-transform: uppercase;
          line-height: 0.938;
          text-align: center;
          @include respond(phone) {
            font-size: 30px !important;
            width: 100%;
          }

          span {
            color: $light-blue;
          }
        }

      }

      .fade-enter-active, .fade-leave-active {
        transition: opacity 1s ease-in;
      }

      .fade-enter-from, .fade-leave-to {
        opacity: 0;
      }

      .fade-enter-to, .fade-leave-from {
        opacity: 1;
      }

      &-img {
        background-image: url('~@/assets/images/boschuling-naslovna.png');
        border-radius: 10px;
        width: 500px;
        height: 400px;
        background-size: cover;
        @include respond(phone) {
          display: block !important;
          width: 90vw;
          height: 300px;
          border-radius: 8px;
        }
      }
    }

    .title {
      font-size: 50px;
      font-family: "Montserrat";
      color: $primary-blue;
      font-weight: bold;
      text-transform: uppercase;
      line-height: 1.3;
      @include respond(from-phone-to-tab) {
        font-size: 40px;
      }
    }
  }

  .description {
    max-width: 70vw;
    text-align: center;
    color: $primary-blue;
    font-size: 22px;
    margin-top: 80px;
    font-family: "Karla";
    opacity: 0;
    transition: opacity 3s ease-out;
    @include respond(phone) {
      text-align: justify;
      margin-top: 30px;
      font-size: 20px;
      max-width: 95vw;
    }
    @include respond(lil-phone) {
      margin-top: 20px;
    }
  }

  .pdfs {
    max-width: 70vw;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    margin-top: 20px;

    .pdf {
      .btn {
        background: linear-gradient(180deg, rgba(93, 132, 183, 0.85) 0%, rgba(36, 85, 151, 0.97) 85%);
        border: none;
        color: white;
        padding: 10px 30px;
        text-transform: uppercase;
        text-decoration: none;
        font-weight: bold;
        transition: transform 0.7s ease-out, color 1s ease;

        &:hover {
          transform: scale(1.1);
        }
      }
    }
  }

  .description.fade-in {
    opacity: 1;
  }
}

.footer {
  position: relative;
  overflow: hidden;

  .cover-img {
    .img {
      position: relative;
      // display: flex;
      //  flex-direction: column;
    }

    .img3 {
      background-image: linear-gradient(to top, rgba(88, 135, 198, 0.74), #5887C6BD), linear-gradient(to bottom, rgb(88, 135, 198, 0.74), #5887C6BD), url('@/assets/images/bottom-bg.png');
      background-repeat: no-repeat;
      background-size: cover;
      // position: relative;
      width: 100%;
      height: 950px;
      @include respond(from-phone-to-tab) {
        height: 620px;
      }
      @include respond(phone) {
        height: 650px;
      }
    }

    img {
      position: relative;
      top: 5px;
    }

    .content {
      position: absolute;
      top: 0;
      width: 100%;
    }
  }
}

</style>
